module.exports = __webpack_public_path__ + "static/media/link.89bd3972.svg";